import { Alert } from '@mui/lab';
import { Snackbar } from '@mui/material';

interface Props {
    message: string;
}

const ErrorSnackbar: React.FunctionComponent<Props> = ({ message }) => {
    return (
        <div>
            <Snackbar
                anchorOrigin={ {
                    vertical: 'bottom',
                    horizontal: 'center',
                } }
                open={ true }>
                <Alert severity="error">{ message }</Alert>
            </Snackbar>
        </div>
    );
};

export default ErrorSnackbar;
